import api from './client';

export const collegesAPI = {
  getAll: async (filters = {}) => {
    const response = await api.get('/colleges', { params: filters });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/colleges/${id}`);
    return response.data;
  },

  getSaved: async () => {
    const response = await api.get('/colleges/saved');
    return response.data;
  },

  save: async (collegeId) => {
    const response = await api.post(`/colleges/saved/${collegeId}`);
    return response.data;
  },

  unsave: async (collegeId) => {
    const response = await api.delete(`/colleges/saved/${collegeId}`);
    return response.data;
  },
};

// Compare API
export const compareAPI = {
  compare: async (collegeIds) => {
    const response = await api.post('/compare/colleges', { college_ids: collegeIds });
    return response.data;
  },

  getSaved: async () => {
    const response = await api.get('/compare/saved');
    return response.data;
  },

  save: async (name, collegeIds) => {
    const response = await api.post('/compare/save', { name, college_ids: collegeIds });
    return response.data;
  },
};

export default collegesAPI;
